import React, { useCallback, useMemo } from "react";
import "./SegmentedTiles.css";

/**
 * 横並びボタン風ラジオ（Carbon不使用）
 * items: [{ id, text }]
 * selectedItem: { id, text } | null
 * onChange: (item|null) => void
 */
export default function SegmentedTiles({
  id,
  legend,
  items,
  selectedItem,
  onChange,
}) {
  const selectedIndex = useMemo(
    () => Math.max(0, items.findIndex((i) => i.id === selectedItem?.id)),
    [items, selectedItem]
  );

  const handleKeyDown = useCallback(
    (e) => {
      if (!["ArrowLeft", "ArrowRight"].includes(e.key)) return;
      e.preventDefault();
      const dir = e.key === "ArrowRight" ? 1 : -1;
      const next = (selectedIndex + dir + items.length) % items.length;
      onChange?.(items[next] || null);
    },
    [selectedIndex, items, onChange]
  );

  return (
    <div className="segtiles">
      {legend && <div className="segtiles__legend">{legend}</div>}

      <div
        className="segtiles__row"
        role="radiogroup"
        aria-labelledby={legend ? `${id}-legend` : undefined}
        onKeyDown={handleKeyDown}
      >
        {items.map((opt) => {
          const active = opt.id === selectedItem?.id;
          return (
            <button
              key={opt.id}
              type="button"
              role="radio"
              aria-checked={active}
              className={`segtiles__btn ${active ? "is-active" : ""}`}
              onClick={() => onChange?.(opt)}
            >
              {opt.text}
            </button>
          );
        })}
      </div>
    </div>
  );
}
